import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { StarIcon } from 'base/components/Icon';
import theme from '../../../theme';
import { getFavoriteIds } from '../../store/favorites/selectors';

const FavoriteToggle = ({ document, favoriteIds }) => (
  <StarIcon
    color={favoriteIds.includes(document.id) ? theme.colors.primary : theme.colors.medium}
  />
);
FavoriteToggle.propTypes = {
  document: PropTypes.objectOf(PropTypes.any).isRequired,
  favoriteIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  // addFavorite: PropTypes.func.isRequired,
  // removeFavorite: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  favoriteIds: getFavoriteIds(state),
});

const mapDispatchToProps = {
  // addFavorite,
  // removeFavorite,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FavoriteToggle);
